import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/[company]/login/content.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/[company]/login/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/header/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientCookiesStore","getCookie","removeCookie","setCookie"] */ "/vercel/path0/services/cookies/client.ts");
